import { useDispatch } from 'react-redux'
import { DEEP_LINKS, DRAWER_KEY, PLAN_STATUS_KEY, SERVICE_ORDER_CONFIRMATION } from 'app-constants'
import { setDrawer } from 'slices/drawer'
import { setPendingConfirmation } from 'slices/serviceOrder'
import { setIsDmaStorage } from 'utils'
import { useHistory } from 'react-router-dom'
import { setModal } from 'slices/modal'
import { useEffect } from 'react'
import { serviceOrderService } from 'services'

export function useDashboardRedirect(selectedContract) {
  const dispatch = useDispatch()
  const history = useHistory()
  const { getServiceOrderDetails } = serviceOrderService()

  useEffect(() => {
    function handleDeepLink(query, drawerKey, pageKey, modalKey) {
      const search = history?.location?.search || ''
      const hasDeepLink = search.includes(query)

      if (hasDeepLink) {
        const isDrawer = !!drawerKey
        const isModal = !!modalKey

        if (isDrawer) {
          setIsDmaStorage(true)
          history.push('/', { shallow: true })
          dispatch(setDrawer(drawerKey))
        } else if (isModal) {
          setIsDmaStorage(true)
          history.push('/', { shallow: true })
          dispatch(setModal({ key: modalKey }))
        } else history.push(pageKey)
      }
    }

    async function hasServicePendingConfirmation() {
      try {
        if (selectedContract.id) {
          const response = await Promise.all(
            SERVICE_ORDER_CONFIRMATION.map(type =>
              getServiceOrderDetails(selectedContract.id, type)
            )
          )
          const [pendingConfirmation] = response
            .map(
              (os, index) =>
                os && {
                  ...os.data,
                  serviceOrderType: SERVICE_ORDER_CONFIRMATION[index],
                }
            )
            .filter(
              data =>
                data &&
                data.expectedInstallationDate &&
                !data.confirmationScheduleDate &&
                !data.confirmationScheduleOrigin
            )
            .sort((a, b) => {
              const dateA = new Date(a.expectedInstallationDate)
              const dateB = new Date(b.expectedInstallationDate)
              return dateA - dateB
            })

          dispatch(setPendingConfirmation(pendingConfirmation))
          if (pendingConfirmation) {
            dispatch(setDrawer(DRAWER_KEY.CONFIRM_SERVICE_SCHEDULE))
            return true
          }
        }
      } catch (error) {
        console.error(error)
      }
      return false
    }

    async function hasContratPendingActivation() {
      const isContractActivationPending =
        selectedContract.contractStatus === PLAN_STATUS_KEY.ST_CONT_EM_ATIVACAO
      if (isContractActivationPending) {
        dispatch(setDrawer(DRAWER_KEY.ACTIVATION_PENDING))
      }
      return isContractActivationPending
    }

    function handleDeepLinkRedirect() {
      DEEP_LINKS.forEach(({ query, drawerKey, pageKey, modalKey }) =>
        handleDeepLink(query, drawerKey, pageKey, modalKey)
      )
    }

    async function handleRedirect() {
      if (await hasServicePendingConfirmation()) return
      if (await hasContratPendingActivation()) return
      handleDeepLinkRedirect()
    }

    handleRedirect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, history, selectedContract.contractStatus, selectedContract.id])
}
